import { useParams, Link } from "react-router-dom";
import { productById, productImage, WHATSAPP_LINKS } from "@/data/products";

const inr = (n) => `₹${n.toLocaleString("en-IN")}`;

const Row = ({ label, value }) => (
  <div style={{ display: "flex", gap: 12, fontSize: 14, lineHeight: 1.5 }}>
    <span style={{ color: "#6B7280", width: 90, flexShrink: 0 }}>{label}</span>
    <span style={{ color: "#111827", fontWeight: 500 }}>{value}</span>
  </div>
);

const ProductDetail = () => {
  const { id } = useParams();
  const product = productById(id);

  if (!product) {
    return (
      <div className="container-vzor" style={{ paddingTop: 60, paddingBottom: 60 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700 }}>Product not found</h1>
        <p style={{ color: "#6B7280" }}>
          The product “{id}” doesn’t exist.{" "}
          <Link to="/" style={{ color: "#0F766E", fontWeight: 600 }}>
            Go home
          </Link>
        </p>
      </div>
    );
  }

  const waHref = WHATSAPP_LINKS[product.id];

  return (
    <div
      className="container-vzor"
      style={{ paddingTop: 32, paddingBottom: 64 }}
      data-testid={`product-detail-${product.id}`}
    >
      <div
        style={{
          display: "grid",
          gap: 40,
          gridTemplateColumns: "1fr",
        }}
        className="pd-grid"
      >
        {/* Image */}
        <div
          style={{
            background: "#F3F4F6",
            borderRadius: 12,
            border: "1px solid #E5E7EB",
            aspectRatio: "1 / 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <img
            src={productImage(product.id)}
            alt={product.name}
            data-testid="product-detail-image"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            onError={(e) => {
              e.currentTarget.style.visibility = "hidden";
            }}
          />
        </div>

        {/* Details */}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <span
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#0F766E",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
              }}
            >
              {product.category} · {product.gender} · {product.tier}
            </span>
          </div>
          <h1
            style={{
              fontSize: 28,
              fontWeight: 700,
              margin: 0,
              letterSpacing: "-0.01em",
            }}
            data-testid="product-detail-name"
          >
            {product.name}
          </h1>
          <div style={{ fontSize: 22, fontWeight: 700 }} data-testid="product-detail-price">
            {inr(product.price_inr)}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              padding: "16px 0",
              borderTop: "1px solid #E5E7EB",
              borderBottom: "1px solid #E5E7EB",
            }}
            data-testid="product-detail-specs"
          >
            <Row label="Frame" value={product.frame} />
            <Row label="Lens" value={product.lens_features.join(" · ")} />
            <Row label="Suits" value={product.face_shapes_suited.join(", ")} />
            <Row label="Colour" value={product.colour} />
          </div>

          <p style={{ color: "#6B7280", fontSize: 14, lineHeight: 1.5, margin: 0 }}>
            {product.pitch}
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 8 }}>
            <button
              className="btn-outline"
              data-testid="add-to-cart-btn"
              type="button"
              style={{ width: "100%" }}
            >
              Add to Cart
            </button>
            <a
              href={waHref}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-wa"
              data-testid={`whatsapp-btn-${product.id}`}
              style={{ width: "100%" }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.966-.273-.099-.471-.148-.67.15-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.695.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.413-.074-.124-.272-.198-.57-.347zM12 2C6.477 2 2 6.477 2 12c0 1.94.552 3.75 1.507 5.286L2 22l4.828-1.484A9.955 9.955 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z" />
              </svg>
              Chat on WhatsApp about this
            </a>
          </div>
        </div>
      </div>

      <style>{`
        @media (min-width: 768px) {
          .pd-grid { grid-template-columns: 1fr 1fr !important; align-items: start; }
        }
      `}</style>
    </div>
  );
};

export default ProductDetail;
